import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

export const useNewInvoiceLink = (): NavLink => {
  const { billing } = useStores();

  return {
    name: "New invoice",
    permissions: [Permission.InvoiceCreate],
    onClick: () => billing.ui.showInvoiceDetailsDialog()
  };
};
